import { render, staticRenderFns } from "./ManualUploadXml.vue?vue&type=template&id=70a2bbc6&scoped=true"
import script from "./ManualUploadXml.vue?vue&type=script&lang=js"
export * from "./ManualUploadXml.vue?vue&type=script&lang=js"
import style0 from "./ManualUploadXml.vue?vue&type=style&index=0&id=70a2bbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2bbc6",
  null
  
)

export default component.exports